import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    connect() {
        this.carousel = null;
        this.ctner = this.element.querySelector('.swiper');
        let config = {
            slidesPerView: "auto",
            spaceBetween: 8,
            freeMode: {
                enabled: true,
                sticky: false,
                momentum: true,
            },
            centeredSlides: true,
            centeredSlidesBounds: true,
            centerInsufficientSlides: true,
            watchOverflow: true,
            observer: true,
            mousewheel: {
                releaseOnEdges: true,
            }
        };
        this.initCarousel(config);
    }
    initCarousel(config) {
        import(/* webpackChunkName: "swiper" */ 'swiper').then(({Swiper}) => {
            import(/* webpackChunkName: "swiper-modules" */ 'swiper/modules').then(({FreeMode, Mousewheel}) => {
                Swiper.use([FreeMode, Mousewheel]);
                this.carousel = new Swiper(this.ctner, config);
            });
        });
    }
}